import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ConsentProvider } from '../components/CookieConsent';
import PageLoader from '../components/PageLoader';
import { paths } from '../routes/paths';

// Site chrome (header + footer) around the attendee-facing and organiser pages. Discover (home) runs
// edge to edge for its full-width hero and lays out its own content; other pages sit in a centred column.
export default function PublicLayout() {
  const { pathname } = useLocation();
  const full = pathname === paths.home || ['/event/', '/tickets', '/orders', '/page/', '/data-rights', '/nearby'].some((p) => pathname.startsWith(p));
  return (
    <ConsentProvider>
      <Header />
      <main className={full ? 'main-full' : 'main-content'}>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </ConsentProvider>
  );
}
